import React, { useState } from "react";
import styles from "./Products.module.sass";
import cn from "classnames";
import Card from "../../../components/Card";
import Form from "../../../components/Form";
import Market from "./Market";
import Dropdown from "../../../components/Dropdown";

const Products = () => {

  const [search, setSearch] = useState(undefined);
  const optionsStatus = ["Select status", "On Sale", "Archived", "Out Of Stock", "All"]
  const [productsFilterBy, setProductsFilterBy] = useState(optionsStatus[0])

  const handleSubmit = (e) => {
    alert();
  };

  return (
    <Card
      className={styles.card}
      title="Products"
      classTitle={cn("title-purple", styles.title)}
      classCardHead={styles.head}
      head={
        <div className={styles.card_header_container}>
          <Form
            className={styles.form}
            value={search}
            setValue={setSearch}
            placeholder="Search by seller id/SKU/Name"
            type="text"
            name="search"
            icon="search"
          />

          <div className={styles.smallDropdownFieldContainer}>
            <Dropdown
              className={styles.smallDropdownField}
              classDropdownLabel={styles.smallDropdownlabel}
              classDropdownHead={styles.dropdownHead}
              value={productsFilterBy}
              setValue={setProductsFilterBy}
              options={optionsStatus}
            />
          </div>

        </div>
      }
    >
      <div className={styles.products}>
        <div className={styles.wrapper}>
          <Market searchBy={search} filterBy={productsFilterBy} />
        </div>
      </div>
    </Card>
  );
};

export default Products;
